
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment créer un site Internet de photographe ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Même s’il a du talent et une belle carte de visite, un photographe professionnel a besoin d’un site Internet de qualité. Voici comment créer le vôtre !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment créer un site Internet de photographe ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Même s’il a du talent et une belle carte de visite, un photographe professionnel a besoin d’un site Internet de qualité. Voici comment créer le vôtre !",
        },
      ],
    };
  },
};
